/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mustchangepassword2Inputs */

const en__field_mustchangepassword2 = /** @type {(inputs: _Field_Mustchangepassword2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must change password`)
};

/**
* | output |
* | --- |
* | "Must change password" |
*
* @param {_Field_Mustchangepassword2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_mustchangepassword2 = /** @type {((inputs?: _Field_Mustchangepassword2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mustchangepassword2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_mustchangepassword2(inputs)
});
export { _field_mustchangepassword2 as "_field_mustChangePassword" }